
(function(){
  var norm=function(e){return e.textContent.replace(/Original price|Current price|\s/gi,'')};
  /* product counts per menu collection, printed by Liquid in the header (window.SE_COUNTS) */
  function cnt(href){var m=(href||'').replace(/^https?:\/\/(www\.)?selletonscales\.com/i,'').match(/^\/collections\/([^\/?#]+)/);var C=window.SE_COUNTS||{};return m&&C.hasOwnProperty(m[1])?C[m[1]]:null;}
  function shown(ul){return ul.querySelectorAll(':scope>li>a[href*="/products/"]').length;}
  function menus(){
    /* Mega-menu "see all" links -> clean "Shop All ..." call-to-action buttons */
    var SHOPALL={'for-all-sizes-of-sl-700-floor-scales':'Shop All Floor Scales','to-visit-all-crane-scales-click-here':'Shop All Crane Scales',
      'for-all-sizes-of-ntep-certified-legal-for-trade-floor-scales-click-here':'Shop All NTEP Floor Scales','for-all-options-of-floor-scale-packages-click-here':'Shop All Floor Scale Packages',
      'for-all-sizes-of-floor-scales-with-pit-frames-click-here':'Shop All Pit Frame Floor Scales','for-all-sizes-of-ramp-floor-scales-card':'Shop All Ramp Floor Scales','view-all-accessories':'Shop All Accessories'};
    Object.keys(SHOPALL).forEach(function(k){
      document.querySelectorAll('li.navmenu-id-'+k).forEach(function(li){
        li.classList.add('se-shopall');
        var a=li.querySelector(':scope>a,:scope>details>summary');if(!a)return;
        var want=SHOPALL[k]+' →';
        for(var i=0;i<a.childNodes.length;i++){var n=a.childNodes[i];if(n.nodeType===3&&n.textContent.trim()){if(n.textContent!==want)n.textContent=want;break;}}
        /* hide it when the collection has nothing beyond what the panel already shows */
        var c=cnt(a.getAttribute('href')||a.getAttribute('data-href')),ul=li.parentNode;
        if(c!==null&&ul&&ul.classList.contains('navmenu-submenu')&&c<=shown(ul))li.classList.add('se-hide');else li.classList.remove('se-hide');
      });
    });
    /* Every mega-menu panel without its own "see all" gets one, linked to that panel's collection */
    document.querySelectorAll('.site-navigation li.navmenu-meganav-sidenav__item').forEach(function(li){
      var sum=li.querySelector(':scope>details>summary[data-href]'),ul=li.querySelector(':scope>details>ul.navmenu-submenu');
      if(!sum||!ul||ul.querySelector(':scope>li.se-shopall'))return;
      var m=(sum.getAttribute('data-href')||'').replace(/^https?:\/\/(www\.)?selletonscales\.com/i,'').match(/^(\/collections\/[^\/?#]+)/);if(!m)return;
      var name=(sum.textContent||'').replace(/\s+/g,' ').trim();if(!name)return;
      name=({'Cargo / Pancake':'Cargo / Pancake Scales','Softwares':'Software','Weigh in Motion Scale systems / Conveyer System':'Weigh-in-Motion Systems','Wrapping Machines / Turn tables':'Wrapping Machines','Animal / Agricultural / Cattle / Farm Scales':'Agricultural Scales','Paper, Nylon Rollers & Ink':'Paper, Rollers & Ink','T Grip & T Strip Moldings':'T-Strip Moldings'})[name]||name;
      var c=cnt(m[1]);if(c===null||c<=shown(ul))return; /* only when there is more to see */
      var n=document.createElement('li');n.className='navmenu-item se-shopall se-auto';
      var a=document.createElement('a');a.className='navmenu-link navmenu-link-depth-3';a.href=m[1];a.textContent='Shop All '+name+' →';
      n.appendChild(a);ul.appendChild(n);
    });
  }
  function content(){
    document.querySelectorAll('ul.collection-filters__filter-list').forEach(function(ul){
      var a=ul.querySelector('a[href*="filters.capacity"],a[href*="filters.platform_size"]');if(!a)return;
      var isCap=/filters\.capacity/.test(a.getAttribute('href'));
      var lis=Array.prototype.slice.call(ul.children);
      var key=function(li){var t=li.textContent.replace(/\(\d+\)/g,'');var n=(t.match(/[\d.,]+/g)||[]).map(function(s){return parseFloat(s.replace(/,/g,''))||0});if(isCap)return n[0]||0;var d=[];t.replace(/([\d.]+)\s*(['"’”])/g,function(_,v,u){d.push(parseFloat(v)*(/['’]/.test(u)?12:1));});return (d[0]||0)*(d[1]||d[0]||0);};
      var s=lis.slice().sort(function(x,y){return key(x)-key(y)});
      if(s.some(function(li,i){return li!==lis[i]}))s.forEach(function(li){ul.appendChild(li)});
    });
    document.querySelectorAll('.price').forEach(function(p){
      var c=p.querySelector('.price__compare-at.visible'),cur=p.querySelector('.price__current');
      if(c&&cur&&norm(c)===norm(cur)){c.classList.remove('visible');c.style.display='none';}
    });
  }
  var t;function later(){clearTimeout(t);t=setTimeout(content,400);}
  function start(){
    menus();content();
    /* v2: prices and filter lists live in the main content; that is the only part watched for changes (AJAX filtering,
       recommendations, recently viewed, option apps). Header menus, drawers, pixels and popups no longer trigger a pass. */
    var main=document.getElementById('site-main')||document.querySelector('main')||document.body;
    new MutationObserver(later).observe(main,{childList:true,subtree:true});
    /* the header is rendered by Liquid; the menu pass repeats once the page has fully loaded and once on the first
       pointer / keyboard / touch contact with the header, in case the theme finished the mobile nav late */
    window.addEventListener('load',menus);
    var once=false;
    ['pointerover','focusin','touchstart'].forEach(function(ev){
      document.addEventListener(ev,function(e){
        if(once||!e.target.closest)return;
        if(e.target.closest('header, .site-header, .site-navigation, [data-mobile-nav], .mobile-nav-panel, [data-site-header]')){once=true;menus();}
      },{passive:true,capture:true});
    });
  }
  if(document.readyState!=='loading'){start();}else{document.addEventListener('DOMContentLoaded',start);}
})();
/* Speed: the Approve financing loader was added site-wide in theme.liquid and pulls ~1.1 MB of JS
   plus Google Maps on every page. Only product + cart pages show financing, so skip it elsewhere
   and on those pages load it after the first tap/scroll (or 2s after page load). */
(function(){
  var isBuy=/(^|\s)template-(product|cart)(\s|$)/.test(document.body.className);
  var orig=Element.prototype.appendChild;
  Element.prototype.appendChild=function(n){
    if(n&&n.tagName==='SCRIPT'&&/approve_plugin_loader/.test(n.src||'')){
      if(!isBuy)return n;
      var self=this,done=false,go=function(){if(done)return;done=true;orig.call(self,n);};
      ['pointerdown','keydown','touchstart','scroll'].forEach(function(e){window.addEventListener(e,go,{once:true,passive:true});});
      if(document.readyState==='complete'){setTimeout(go,2000);}else{window.addEventListener('load',function(){setTimeout(go,2000);});}
      return n;
    }
    return orig.call(this,n);
  };
})();

/* Speed: YouTube embeds (product descriptions) load ~1 MB each up front.
   v2: snippets/product.liquid prints the description with the player address in data-se-yt instead of src, so nothing
   downloads while the page loads. This swaps each one for its thumbnail + play button; the real player loads only when
   clicked. Legacy iframes that still carry a src (other templates) are swapped the same way, as in v1.
   Safety net: an iframe that for any reason still has data-se-yt and no facade 8 s after load gets its src back. */
(function(){
  var SEL='iframe[data-se-yt],iframe[src*="youtube.com/embed/"],iframe[src*="youtube-nocookie.com/embed/"]';
  function restore(f){var s=f.getAttribute('data-se-yt');if(s&&!f.getAttribute('src'))f.setAttribute('src',s);f.removeAttribute('data-se-yt');}
  function facade(f){
    var src=f.getAttribute('data-se-yt')||f.getAttribute('src')||'';
    var m=src.match(/embed\/([\w-]{6,})/);if(!m){restore(f);return;}
    var id=m[1],w=f.getAttribute('width'),h=f.getAttribute('height'),num=/^\d+$/.test(w||'')&&/^\d+$/.test(h||'');
    var d=document.createElement('button');d.type='button';d.className='se-yt';d.setAttribute('aria-label','Play video: '+(f.title||'YouTube video'));
    d.style.aspectRatio=num?(w+'/'+h):'16/9';if(num)d.style.maxWidth=w+'px';var pc=getComputedStyle(f);if(pc.position==='absolute'){d.style.position='absolute';d.style.inset='0';d.style.height='100%';d.style.maxWidth='none';d.style.margin='0';}
    d.innerHTML='<img loading="lazy" alt="" src="https://i.ytimg.com/vi/'+id+'/hqdefault.jpg"><span class="se-yt__play"></span>';
    d.addEventListener('click',function(){var n=document.createElement('iframe');n.src='https://www.youtube.com/embed/'+id+'?autoplay=1&rel=0';n.allow='accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture';n.allowFullscreen=true;n.title=f.title||'YouTube video';n.style.cssText='position:absolute;inset:0;width:100%;height:100%;border:0';d.innerHTML='';d.appendChild(n);});
    f.parentNode.replaceChild(d,f);
  }
  function swap(){
    document.querySelectorAll(SEL).forEach(function(f){
      if(f.closest('.se-yt'))return;
      try{facade(f);}catch(e){restore(f);}
    });
  }
  if(document.readyState!=='loading')swap();else document.addEventListener('DOMContentLoaded',swap);
  window.addEventListener('load',function(){setTimeout(function(){document.querySelectorAll('iframe[data-se-yt]').forEach(restore);},8000);});
})();

/* Product page: "key specs" strip under the price, built from the same filters.* metafields
   that power the collection filters (Liquid prints them into #se-specs). */
(function(){
  function build(){
    var el=document.getElementById('se-specs');if(!el||document.querySelector('.se-specs'))return;
    var s;try{s=JSON.parse(el.textContent)}catch(e){return}
    var price=document.querySelector('.product-main .product__price, .product__price');if(!price)return;
    var num=function(v){return parseFloat(String(v).replace(/[^\d.]/g,''))||0};
    var area=function(v){var d=[];String(v).replace(/([\d.]+)\s*(['"’”])/g,function(_,n,u){d.push(parseFloat(n)*(/['’]/.test(u)?12:1))});return (d[0]||0)*(d[1]||d[0]||0)};
    var chips=[];
    if(s.cap&&s.cap.length){var c=s.cap.slice().sort(function(a,b){return num(a)-num(b)});chips.push(['Capacity',c.length>1?c[0].replace(/ lb$/,'')+' – '+c[c.length-1]:c[0]]);}
    if(s.size&&s.size.length){var z=s.size.slice().sort(function(a,b){return area(a)-area(b)});chips.push(['Platform',z.length>2?z[0]+' to '+z[z.length-1]+' ('+z.length+' sizes)':z.join(', ')]);}
    if(s.ntep&&s.ntep.length){var n=s.ntep.join(' / ');chips.push(['Certification',/^NTEP/.test(n)&&s.ntep.length===1?'NTEP – Legal for Trade':(s.ntep.length>1?'NTEP & non-NTEP options':'Non-NTEP – Industrial use'),/^NTEP/.test(n)&&s.ntep.length===1?'ok':'']);}
    if(s.usa&&s.usa.length)chips.push(['Built in','USA','ok']);
    if(s.feat&&s.feat.length)chips.push(['Features',s.feat.join(' · ')]);
    if(!chips.length)return;
    var box=document.createElement('dl');box.className='se-specs';
    chips.forEach(function(c){var w=document.createElement('div');w.className='se-specs__item'+(c[2]?' se-specs__item--'+c[2]:'');var t=document.createElement('dt');t.textContent=c[0];var v=document.createElement('dd');v.textContent=c[1];w.appendChild(t);w.appendChild(v);box.appendChild(w);});
    price.parentNode.insertBefore(box,price.nextSibling);
  }
  if(document.readyState!=='loading')build();else document.addEventListener('DOMContentLoaded',build);
})();
/* Speed: mega-menu images (~200) are rendered with data-se-src so they don't compete with the page's
   main image. Load them on first header interaction, or shortly after the page has finished loading. */
(function(){
  var done=false;
  function hydrate(){
    if(done)return;done=true;
    document.querySelectorAll('img[data-se-src]').forEach(function(i){
      if(i.dataset.seSrcset){i.srcset=i.dataset.seSrcset;i.removeAttribute('data-se-srcset');}
      i.src=i.dataset.seSrc;i.removeAttribute('data-se-src');
    });
  }
  ['pointerover','touchstart','focusin','click'].forEach(function(ev){
    document.addEventListener(ev,function(e){
      if(e.target.closest&&e.target.closest('header, .site-header, .site-navigation, [data-mobile-nav], .mobile-nav-panel, [data-site-header]'))hydrate();
    },{passive:true,capture:true});
  });
  function later(){setTimeout(function(){(window.requestIdleCallback||setTimeout)(hydrate);},3500);}
  if(document.readyState==='complete')later();else window.addEventListener('load',later);
})();
